import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
import { EmptyState } from '../components/ui/EmptyState';

/** Shown for unknown routes and for errors thrown while rendering a route. */
export function RouteErrorPage() {
  const error = useRouteError();
  // Rendered without an error by the catch-all route: that is a plain "not found".
  const notFound = error == null || (isRouteErrorResponse(error) && error.status === 404);
  return (
    <div className="flex min-h-dvh items-center justify-center bg-surface-muted">
      <EmptyState
        title={notFound ? 'Page not found' : 'Something went wrong'}
        description={
          notFound
            ? 'The page you are looking for does not exist or has moved.'
            : 'An unexpected error occurred. Reload the page or go back to the start.'
        }
        action={
          <Link className="text-sm font-medium text-brand-700 underline-offset-4 hover:underline" to="/">
            Go to start
          </Link>
        }
      />
    </div>
  );
}
